import { AttrField } from 'vuex-orm-decorators'
import TmLogicError from '@/core/error/tmLogicError'
import { mapStringOrNumberToEnum } from '@/utils/mapStringOrNumberToEnum'

export const TmArrayStringField = () =>
  AttrField([], (value: unknown) => {
    if (!Array.isArray(value)) {
      throw new TmLogicError(`value should be type "Array"`)
    }
    return value.map((t) => {
      return t.toString()
    })
  })

export const TmEnumField = (enumObj: { [key: string]: string | number }, fallback: string | number) => {
  return AttrField(undefined, (value: unknown) => {
    try {
      if (typeof value !== 'string' && typeof value !== 'number') {
        throw new TmLogicError(
          `Enum value should be type "string" | "number". Actual type === "${typeof value}", value = "${value}"`,
        )
      }
      return mapStringOrNumberToEnum(value, enumObj)
    } catch (e) {
      if (typeof window?.console?.error === 'function') {
        if (e instanceof Error) {
          window.console.error(e.message, e.stack)
        } else {
          window.console.error('Unexpected error', e)
        }
      }

      return fallback
    }
  })
}
